export default __webpack_public_path__ + "static/media/OUTLND-text-logo.520e623d.png";